import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  templateList: [],
  isAddTemplateOpen: false,
  isAvailableForOpen: false,
  pageCount: 0,
  page: 1,
  totalItems: 0,
  itemsPerPage: 10,
  searchFilters: {
    search: "",
    sortBy: "id",
    sortOrder: "asc",
    selectedOrg: "",
    selectedUser: "",
  },
  recordToEdit: null,
  selectedOrg: null,
  selectedUser: null,
};

const useTemplateStore = create(
  devtools((set) => ({
    ...initialState,
    setTemplateList: (templateList) => set({ templateList }),
    setIsAddTemplateModalOpen: (isAddTemplateOpen) => set({ isAddTemplateOpen }),
    setIsAvailableForModalOpen: (isAvailableForOpen) => set({ isAvailableForOpen }),
    setPageCount: (pageCount) => set({ pageCount }),
    setPage: (page) => set({ page }),

    setSearchFilters: (searchFilters) => set({ searchFilters }),
    setRecordToEdit: (recordToEdit) => set({ recordToEdit }),
    setTotalItems: (totalItems) => set({ totalItems }),
    setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),

    reset: () => set(initialState),
  })),
);

export default useTemplateStore;
